import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Facebook, Instagram, Youtube } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_4d83666a-aa6c-4973-8e91-b3c87719f098/artifacts/zqkw8qrg_sports-logo-generator-for-a-soccer-team-league-5384a-el1%20%286%29.webp"
                alt="Football X Academy"
                className="h-14 w-auto"
              />
              <div className="text-xl font-bold">
                <span className="text-white">FOOTBALL</span>
                <span className="text-cyan-400 ml-1">X</span>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              Developing the next generation of football talent through elite coaching and comprehensive youth programs.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-cyan-400 font-semibold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/academy" className="block text-gray-300 hover:text-cyan-400 transition-colors">
                Football X Academy
              </Link>
              <Link to="/elite-trial-prep" className="block text-gray-300 hover:text-cyan-400 transition-colors">
                Elite Trial Prep
              </Link>
              <Link to="/joeys" className="block text-gray-300 hover:text-cyan-400 transition-colors">
                Joeys Program
              </Link>
              <Link to="/social" className="block text-gray-300 hover:text-cyan-400 transition-colors">
                Football X Media
              </Link>
              <Link to="/sponsor" className="block text-gray-300 hover:text-cyan-400 transition-colors">
                Become a 2027 Sponsor
              </Link>
              <Link to="/shop" className="block text-gray-300 hover:text-cyan-400 transition-colors">
                Shop
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-cyan-400 font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-cyan-400" />
                <span className="text-gray-300">paul.minett@football-x.com.au</span>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-cyan-400 font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/p/Football-X-Academy-100053262415608/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-cyan-400 transition-colors"
              >
                <Facebook className="w-6 h-6" />
              </a>
              <a
                href="https://instagram.com/football_x_academy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-cyan-400 transition-colors"
              >
                <Instagram className="w-6 h-6" />
              </a>
              <a
                href="https://youtube.com/@footballx-media"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-cyan-400 transition-colors"
              >
                <Youtube className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col items-center justify-center mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_4d83666a-aa6c-4973-8e91-b3c87719f098/artifacts/hurf4oz3_X%20Global%20Sports.PNG"
              alt="X Global Sports"
              className="h-28 w-auto mb-3 drop-shadow-[0_0_15px_rgba(234,179,8,0.4)]"
              data-testid="x-global-sports-logo"
            />
            <p className="text-gray-300 text-sm tracking-widest uppercase" data-testid="division-text">
              A Division of X Global Sports
            </p>
          </div>
          <p className="text-gray-400 text-center">
            © 2025 Football X. All rights reserved. | Developing champions on and off the field.
          </p>
        </div>
      </div>
    </footer>
  );
};